import styled from 'styled-components';
import ArrowIconSvg from '@catalogo/theme-svg/arrow.svg';

export const Wrapper = styled.div<{ $isVisible: boolean }>`
  padding: 16px 8px;
  margin: 0px 8px;
  display: flex;
  place-content: space-between;
  cursor: pointer;
  text-transform: ${({ theme }) => theme.titleTransform};
  ${({ $isVisible }) => $isVisible && 'border-bottom: 1px solid #e8e8e8;'}

  @media (min-width: 1024px) {
    padding: 24px 0;
    margin: 0 16px;
  }
`;

export const Text = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.titleColor};

  @media (min-width: 1024px) {
    font-size: 21px;
  }
`;

export const ArrowButton = styled.button`
  background: transparent;
  border: none;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primaryColor};
    border-radius: 2px;
  }
`;

export const ArrowIcon = styled(ArrowIconSvg)<{ $isVisible: boolean }>`
  fill: ${({ theme }) => theme.titleColor};
  width: 12px;
  height: 12px;
  display: flex;
  flex-direction: column;
  align-self: center;
  ${({ $isVisible }) => $isVisible && `transform: rotate(180deg);`}
  transition: transform 500ms;
`;
